export default __webpack_public_path__ + "static/media/msf_background_xl1.cadc6ea4.jpg";